import React, { FC, useLayoutEffect, useState } from 'react'
import { sleep } from '@dt/fe-utils'
import { Input, Icon } from '@cps'
import { restaurantConfig } from 'restaurant'
import markerImg from '@img/mapMarker.png'
import markerImgStore from '@img/storeMarker.png'
import storeChangeImg from '@img/storeChange.png'
import { isNaN } from '@dt/fe-utils/dist/lodash'
import './index.scss'

// interface
interface IProps {
  location: {
    latitude: number;
    longitude: number;
  };
  isSearch: boolean;
  handleStoreClassify: {};
  storeDetail: any;
  mapShow?(type: boolean): void;
  setIsStoreMore(type: boolean): void;
  setSearchTitle(obj: string): void;
  onSelectStore?(store?: IViewStore): void;
}
let map: any
let label: any
const BaiduMap: FC<IProps> = (props: IProps) => {
  const { location, handleStoreClassify, isSearch, storeDetail, mapShow, setIsStoreMore, setSearchTitle, onSelectStore } = props
  const [searchArr, setSearchArr] = useState<any[]>([])
  const [mapEnd, setMapEnd] = useState<boolean>(false)
  // 地图初始化
  const initMap = () => {
    let myLatlng = new google.maps.LatLng(location.latitude, location.longitude)
    const mapProp = {
      center: myLatlng,
      zoom: 16,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      zoomControl: false,
      scaleControl: false,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
    }
    const dom = document.getElementById('googleMap')
    map = new google.maps.Map(dom, mapProp)
    const marker = new google.maps.Marker({
      position: myLatlng,
      icon: {
        url: markerImg,
        scaledSize: new google.maps.Size(20, 32)
      },
      map
    })
    marker.setMap(map)
    setMapEnd(true)
  }
  // 切换门店点时候，中心点偏移
  const setCenter = (location) => {
    let point = new google.maps.LatLng(location.latitude, location.longitude)
    map.setCenter(point)
  }

  // 处理店铺名显示
  const dealStoreName = (storeName = '') => {
    storeName = storeName.trim()
    let offsetY = -8
    let name = ''
    let nArr = storeName.split(' ')
    if (nArr.length > 1) {
      nArr.forEach((str, idx) => {
        name += str + ' '
        if (name.zhLength() + (nArr[idx + 1] || '')?.zhLength() > 9 && !/<\/br>/.test(name)) {
          name.zhLength() > 10 && (name += '...')
          name += '</br>'
          offsetY = -15
        }
      })
      const [line1, line2 = ''] = name.split(/<\/br>/g)
      if (line2.zhLength() > 9) {
        name = name.replace(line2, '')
        name += (line2.slice(0, 14) + '...')
      }
    } else {
      const line1 = storeName.slice(0, 18)
      const line1Len = line1.zhLength()
      if (line1Len > 9) {
        const _l1s = 9 + (18 - line1Len)
        const _line1 = storeName.slice(0, _l1s)
        const line2 = storeName.slice(_line1.length, _line1.length + 18)
        const line2Len = line2.zhLength()
        const _l2s = _l1s + 9 + (18 - line2Len)
        const _line2 = line2Len > 9 ? storeName.slice(_l1s, _l2s - 3) + '...' : storeName.slice(_l1s, _l2s)
        name = `${_line1}</br>${_line2}`
        offsetY = -15
      } else {
        name = storeName
      }
    }
    return { name, offsetY }
  }

  const setLabel = (storeDetail, location, zIndex = 6, marker?) => {
    let { storeName } = storeDetail
    let { name, offsetY } = dealStoreName(storeName)
    let infowindow = new google.maps.InfoWindow({
      content: name,
      position: new google.maps.LatLng(location.latitude, location.longitude),
    })
    if (map) {
      infowindow.open(map, marker)
    }
    return infowindow
  }

  // 商户标记的方法,执行一次
  const storeMarker = async (handleStoreClassify) => {
    if (!map) return
    handleStoreClassify.boughtList.forEach((item) => setMarker(item))
    handleStoreClassify.moreList.forEach((item) => setMarker(item))
  }
  const setMarker = (item) => {
    if (isNaN(item.lbsLat) || !item.lbsLat) return
    const myIcon = markerImgStore
    const storeChangeImgIcon = storeChangeImg
    let icon = {
      url: myIcon,
      scaledSize: new google.maps.Size(32, 32)
    }
    let zIndex = 2
    let location = { longitude: item.lbsLng, latitude: item.lbsLat }
    let point = new google.maps.LatLng(item.lbsLat, item.lbsLng)

    if (restaurantConfig.storeId === item.storeId) {
      zIndex = 5
      // icon = {
      //   url: storeChangeImgIcon,
      //   scaledSize: new google.maps.Size(164, 50)
      // }
    }
    let marker = new google.maps.Marker({
      position: point,
      icon,
      map
    })
    marker.setZIndex(zIndex)
    setLabel(item, location, zIndex + 1, marker)
    google.maps.event.addListener(marker, 'click', function () {
      const location = {
        longitude: point.lng,
        latitude: point.lat
      }
      const storeDetail = {
        ...item
      }
      changeCenter(location)
      setLabel(storeDetail, location, zIndex + 1, marker)
      onSelectStore(storeDetail)
    })
  }
  // 搜索
  const searchLocal = (value: string) => {
    if (!value || !map) return
    const service = new google.maps.places.PlacesService(map)
    const request = {
      // query: 'Museum of Contemporary Art Australia',
      query: value,
      fields: ['name', 'geometry'],
    }
    service.textSearch(request, (results, status) => {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        // for (var i = 0; i < results.length; i++) {
        //   createMarker(results[i])
        // }
        setSearchArr(results)
      }
    })
  }

  // 地图选择中心点
  const changeCenter = async (point) => {
    if (map) {
      map.setCenter(point)
      mapShow(false)
      setIsStoreMore(false)
    }
  }

  useLayoutEffect(() => {
    const $sleep = sleep(() => {
      return window.initGoogleMapSDKStatus
    }, 300)
    $sleep(() => {
      initMap()
      storeMarker(handleStoreClassify)
    })
  }, [])
  useLayoutEffect(() => {
    if (!mapEnd) return

    setTimeout(() => {
      storeDetail && setCenter(location)
    }, 2000)
  }, [location, storeDetail, mapEnd])

  return (
    <div className='google-map store-map-show-area'>
      {isSearch && (
        <div className='info'>
          <Icon
            name='chevron-left'
            onClick={() => {
              mapShow(false)
            }}
          />
          <Input
            placeholder={i18n.t('store.storeGoAdd')}
            onChange={(e: any) => searchLocal(e.target.value)}
            autoFocus
          />
        </div>
      )}
      {
        isSearch && (
          <div
            className='search-area'
          >
            {
              searchArr.map((item: any, index: number) => {
                return (
                  <div
                    key={index} className='search-item'
                    onClick={() => {
                      changeCenter(item.geometry.location)
                      setSearchTitle(item.name)
                      setSearchArr([])
                    }}
                  >
                    <div className='title'>{item.name}</div>
                    <div className='des'>{item.formatted_address}</div>
                  </div>
                )
              })
            }
          </div>
        )
      }
      <div id='googleMap'></div>
    </div>
  )
}

export default BaiduMap
